import React from 'react'
import PropTypes from 'prop-types'

import styles from '../scss/ui/slider.scss'

class PagingDots extends React.Component {
    constructor() {
        super()
        this.getIndexes = this.getIndexes.bind(this)
    }

    getIndexes() {
        const { slidesToScroll, dots } = this.props
        const arr = []
        for (let i = 0; i < dots; i += slidesToScroll) {
            arr.push(i)
        }
        return arr
    }

    render() {
        const { goToSlide, currentSlide } = this.props
        const indexes = this.getIndexes()

        return (
            <ul className={styles.pagingDotList}>
                {indexes.map(index => (
                    <li
                        key={index}
                        className={currentSlide === index ?
                            styles.pagingDotListItemActive :
                            styles.pagingDotListItem
                        }
                    >
                        <button
                            className={currentSlide === index ?
                                styles.pagingDotActive :
                                styles.pagingDot
                            }
                            onClick={goToSlide.bind(null, index)}
                            type="button"
                        >
                            &bull;
                        </button>
                    </li>
                ))}
            </ul>
        )
    }
}

PagingDots.propTypes = {
    dots: PropTypes.number.isRequired,
    slidesToScroll: PropTypes.number.isRequired,
    goToSlide: PropTypes.func.isRequired,
    currentSlide: PropTypes.node.isRequired,
}

export default PagingDots



// WEBPACK FOOTER //
// ./src/ui/PagingDots.js